import './style.css'
import React from 'react'
import data from './data.json'
import {connect} from 'react-redux'
import '../../style.css'
import Header4 from 'src/components/Header/Header4'
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import {MainBottom} from 'src/components/Pages/Guide/component/index'
import {unitsList} from 'src/components/Pages/Guide/component/Datas/normalDatas'
import {useHistory} from 'react-router-dom';
import { Breadcrumb } from 'antd';

function SatelliteDetail(props) {
    const params = new URLSearchParams(props.location.search);
    const id = parseInt(params.get('id'));
    const MenuIndex = params.get('selectMenuIndex');


    function handleBack() {
        history.push({
            pathname: '/Introduce',
            state: {index: parseInt(MenuIndex)}
        });
    }


    const history = useHistory();
    const images = require.context('../../../img', true);
    let testData = data[id];
    let imageUrl = testData.image;
    const sateliteImage = images(`./${imageUrl}`);

    const abilityTableImage = images("./高分三号卫星成像模式和能力表.png");
    const loadTableImage = images("./高分五号卫星载荷及配置表.png");
    const LTTableImage = images("./LT1A1B成像模式.jpg")
    const HJ2ETableImage = images("./HJ-2E成像模式.jpg")
    const CM1TableImage = images("./CM1有效载荷指标.jpg")
    const DQ1TableImage = images("./CM1有效载荷指标.jpg")
    const GF3B3CTableImage = images("./GF3CGF3B成像模式.jpg")
    const GF5BTableImage = images("./GF5B有效载荷指标.png")
    let loadIndexTableData = testData.loadTable;

    function buttomTable() {
        if (id === 20) {
            return (
                <img className='Table_Image' src={abilityTableImage} alt={"正在加载图片"}></img>
            )
        }
        if (id === 21) {
            return (
                <img className='Table_Image' src={loadTableImage} alt={"正在加载图片"}></img>
            )
        }
        if (id === 14 || id === 15) {
            return (
                <img className='Table_Image' src={LTTableImage} alt={"正在加载图片"}></img>
            )
        }
        if(id === 17) {
            return (
                <img className='Table_Image' src={HJ2ETableImage} alt={"正在加载图片"}></img>
            )
        }
        if(id == 19) {
            return (
                <img className='Table_Image' src={CM1TableImage} alt={"正在加载图片"}></img>
            )
        }
        if(id == 22) {
            return (
                <img className='Table_Image' src={DQ1TableImage} alt={"正在加载图片"}></img>
            )
        }
        if(id == 11 || id == 12) {
            return (
                <img className='Table_Image' src={GF3B3CTableImage} alt={"正在加载图片"}></img>
            )
        }
        if(id == 10) {
            return (
                <img className='Table_Image' src={GF5BTableImage} alt={"正在加载图片"}></img>
            )
        }
        return (
            <table className='Load_Index_Table'>
                <thead>
                {generateTableHeader()}
                </thead>
                <tbody>
                {renderTableData()}
                </tbody>
            </table>
        );
    }


    function generateTableHeader() {
        return (
            <tr>
                {loadIndexTableData.map((row, index) => (
                    <th key={index}>{row[0]}</th>
                ))}
            </tr>
        );
    }


    const renderTableData = () => {
        let rowData = [];
        let rowSpanData = [];
        for (let i = 1; i < loadIndexTableData[0].length; i++) {
            let row = [];
            let rowSpan = [];
            for (let j = 0; j < loadIndexTableData.length; j++) {
                row.push(loadIndexTableData[j][i]);
                if (loadIndexTableData[j][i] !== null || (i === 1 && loadIndexTableData[j][i] === null)) {
                    let span = 1;
                    for (let k = i + 1; k < loadIndexTableData[0].length; k++) {
                        if (loadIndexTableData[j][k] === null) {
                            span++;
                        } else {
                            break;
                        }
                    }
                    rowSpan.push(span);
                } else {
                    rowSpan.push(0);
                }
            }
            rowData.push(row);
            rowSpanData.push(rowSpan);
        }

        

        console.log(rowData)


        return rowData.map((row, rowIndex) => {
            return (
                <tr key={rowIndex}>
                    {row.map((cell, colIndex) => {
                        if (rowSpanData[rowIndex][colIndex] > 0) {
                            return (
                                <td key={colIndex} rowSpan={rowSpanData[rowIndex][colIndex]} >
                                    {cell}
                                </td>
                            );
                        } else {
                            return null;
                        }
                    })}
                </tr>
            );
        });
    };


    return (
        <div className='Home_Introduce'>
            <div className='Home_IntroduceMain' id='Home_IntroduceMain'>
                {/* <Header4></Header4> */}
                <div className='Home_IntroduceTitle'>
                    {props.loginObj && props.loginObj.login && props.loginObj.token !== undefined
                        ?
                        <Header4/>
                        :
                        <HomeHearder/>
                    }
                </div>
                <div className='Home_IntroduceMainScroll'>
                    <div className='Home_IntroduceContent'>
                        <div className='Home_IntroduceContentMain'>
                            <div className='Satellite_Detail_Container'>

                                <div className='Satellite_Detail_Background'>
                                    {/*<div className='Bread_Crumbs'>*/}
                                        <Breadcrumb className="Bread_Crumbs">
                                            <Breadcrumb.Item className="Satellite_System_Text" onClick={handleBack}>卫星系统</Breadcrumb.Item>
                                            <Breadcrumb.Item className="Satelite_Name_Text" >{testData.name}</Breadcrumb.Item>
                                        </Breadcrumb>
                                        {/*<div className='Satellite_System_Text' onClick={handleBack}>*/}
                                        {/*    卫星系统/*/}
                                        {/*</div>*/}
                                        {/*<div className='Satelite_Name_Text'>{testData.name}</div>*/}
                                    {/*</div>*/}
                                    <div className='Satelite_Title_Board'>
                                        <img className='Satelite_Image' src={sateliteImage} alt={"正在加载图片"}></img>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <th className="LeftColumn">卫星名称:</th>
                                                <th className="RightColumn">{testData.name}</th>
                                            </tr>
                                            <tr>
                                                <td className="LeftColumn">代号:</td>
                                                <td className="RightColumn">{testData.id}</td>
                                            </tr>
                                            <tr>
                                                <td className="LeftColumn">发射时间:</td>
                                                <td className="RightColumn">{testData.transmissionTime}</td>
                                            </tr>
                                            <tr>
                                                <td className="LeftColumn">设计寿命/年:</td>
                                                <td className="RightColumn">{testData.designLife}</td>
                                            </tr>
                                            <tr>
                                                <td className="LeftColumn">在轨工作状态:</td>
                                                <td className="RightColumn">{testData.workState}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='Graph_Board'>
                                        <div className='graphTitle'>简介:</div>
                                        <div className='Description_Text'> {testData.description}</div>
                                    </div>
                                    <div className='Graph_Board'>
                                        <div className='graphTitle'>轨道参数表:</div>
                                        <table className='Track_Parameter_Table'>
                                            <tbody>
                                            <tr>
                                                <td>参数名</td>
                                                <td>轨道类型</td>
                                                <td>轨道高度/km</td>
                                                <td>{id !== 19 ? "轨道倾角/°" : "定点位置"}</td>
                                                {id !== 19 ?
                                                    <td>降交点地方时/am</td> : null}
                                                {id !== 19 ?
                                                    <td>覆盖周期/天</td> : null}
                                            </tr>
                                            <tr>
                                                <td>参数值</td>
                                                <td>{testData.trackTabel.type}</td>
                                                <td>{testData.trackTabel.height}</td>
                                                <td>{testData.trackTabel.angel}</td>
                                                {id !== 19 ?
                                                    <td>{testData.trackTabel.time}</td>
                                                    : null
                                                }
                                                {id !== 19 ?
                                                    <td>{testData.trackTabel.coveragePeriod}</td>
                                                    : null}
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='Graph_Board'>
                                        <div
                                            className='graphTitle'>{id !== 20 && id !== 14 && id !== 15 && id !== 17 && id !== 11 && id !== 12? "载荷指标表:" : "成像模式和能力表:"}</div>
                                        {
                                            buttomTable()
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <MainBottom data={unitsList}/>
                </div>
            </div>
        </div>
    )
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({})
export default connect(mapState, mapDispatch)(SatelliteDetail);